<script>
  import { trackLinkClick } from '../../../../../../../js/trackLinkClick';

  // Props
  export let id;
  export let url;
  export let linkText;
  export let ariaLabel;

  // Variables
  const textWords = linkText.split(/(\s+)/);
  const textLastWord = textWords.pop(); // TODO (@leeryan): Text splitting should not be occurring for JP, figure out how to retrieve locale from within PWN
  const textExceptLastWord = textWords.join('');
</script>

<a {id} class="ArrowLink" href={url} aria-label={ariaLabel} use:trackLinkClick={{ id, title: linkText, url }}>
  {textExceptLastWord}
  <span class="no-wrap">
    {textLastWord}
  </span>
</a>

<style>@charset "UTF-8";
.ArrowLink {
  color: var(--color-text, #1a1a1a);
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 14px;
  font-weight: var(--font-weight-medium, 500);
  line-height: 24px;
  text-decoration: none;
}
.ArrowLink span::after {
  content: "→";
  pointer-events: none;
  display: inline-block;
  margin-left: 0.25em;
  transition: transform 150ms cubic-bezier(0.4, 0, 0.6, 1);
  white-space: nowrap;
}
.ArrowLink span.no-wrap {
  white-space: nowrap;
}
@keyframes slide-forward {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(35%);
  }
}
.ArrowLink:hover span::after {
  animation-name: slide-forward;
  animation-duration: 375ms;
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  animation-iteration-count: 2;
  animation-direction: alternate;
}</style>
